import { Component, OnInit, AfterViewInit } from '@angular/core';
import {MapService} from '../../core/map/map.service';
import {AuthService} from '../../core/auth/auth.service';
import {SettingsService} from '../../core/settings/settings.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, AfterViewInit {

  id = 'map';

  constructor(public mapService: MapService,
              private authService: AuthService,
              private settingsService: SettingsService) { }

  ngOnInit() {
    this.authService.logOut.subscribe((doLogout) => {
      if (doLogout) {
        this.mapService.clearFilters();
      }
    });
  }

  ngAfterViewInit() {
    this.mapService.initMap(this.id);
  }

  redoPlaceSearch() {
    this.mapService.searchPlaces();
  }

  toggleLasso() {
    this.mapService.toggleLasso();
  }

  zoomIn() {
    this.mapService.zoomIn();
  }

  zoomOut() {
    this.mapService.zoomOut();
  }

}



// WEBPACK FOOTER //
// ./client/app/components/map/map.component.ts